export const zoologyData = {
  departmentName: "Department of Zoology",
  bannerImage: "/zoology/Zoologybanner.JPG",
  
  about: {
    title: "About the Department",
    content: `The Department of Zoology at Rayalaseema University is dedicated to the comprehensive study of animal 
    diversity, physiology, ecology, evolution, and conservation. Our programs provide thorough understanding of animal 
    life from molecular to ecosystem levels. We emphasize practical training through field studies, laboratory work, 
    and research projects. The department is committed to fostering scientific curiosity and preparing students for 
    careers in wildlife conservation, research, education, and biotechnology.`,
    highlights: [
      "Museum with extensive collection of animal specimens",
      "Advanced microscopy and physiology laboratories",
      "Research in animal physiology, ecology, and biodiversity",
      "Regular field studies and biodiversity surveys",
      "Focus on wildlife conservation and environmental protection"
    ]
  },

  brochure: {
    title: "Department Brochure",
    pdfLink: "/zoology/department-brochure.pdf",
    description: "Download our department brochure."
  },

  hod: {
    
      id: "zoo002",
      name: "Dr. Bandela Vijayudu",
      designation: "Co-ordinator,Assistant Professor (C)",
      email: "bandelavijay5@gmail.com",
      mobile: "8374742791",
      photo: "/zoology/bandela.JPG",
      qualification: "M.Sc., Ph.D.,CSIR-NET,APSET",
      specialization: "Developmental Biology , Genetics and Evaluation",
      profileLink: "/zoology/BANDELA.pdf",
   
    // id:"bot001",
    // name: "Dr. Bharath Kumar Ravuru",
    //   designation: "Professor & Head",
    //   email: "drbharathravuru@gmail.com",
    //   mobile: "8500722075",
    //   photo: "/botany/bharath.JPG",
    //   qualification: "M.Sc., Ph.D.",
    //   specialization: "Plant Biotechnology, Ethnobotany &  Forest Ecology",
    //   profileLink: "/botany/bharath.pdf",
    
    message: `Welcome to the Department of Zoology at Rayalaseema University. We are committed to excellence in 
    zoological education and research. Our department provides comprehensive knowledge of animal sciences and encourages 
    students to explore the fascinating world of animal life. Join us in contributing to wildlife conservation and 
    advancing our understanding of the animal kingdom.`,
   
  },

  bos: {
  title: "Zoology",
  members: [
    {
      name: "Prof. V. Lokanath",
      designation: "Chairperson",
      affiliation: "Dept. of Zoology, Dravidian University, Kuppam"
    },
    {
      name: "Prof. Edukondalu",
      designation: "Member",
      affiliation: "Dept. of Marine Living Resources, Andhra University, Visakhapatnam"
    },
    {
      name: "Prof. Senthil Kumar",
      designation: "Member",
      affiliation: "University of Hyderabad, Hyderabad"
    },
    {
      name: "Mr. B. Gangi Reddy",
      designation: "Member",
      affiliation: "Director, Rathna Biotech Pvt. Ltd., Palamaner, Chittoor"
    },
    {
      name: "Prof. P. Jacob Doss",
      designation: "Member",
      affiliation: "Dept. of Zoology, S.V. University, Tirupati"
    }
  ]
}
,

  faculty: [
    
    {
      id: "zoo001",
      name: "Dr. M. Nagabhushan Reddy",
      designation: "Assistant Professor (MTS)",
      email: "mnabhushr@yahoo.com",
      mobile: "8500981295",
      photo: "/zoology/Drnagabushion.JPG",
      qualification: "M.Sc., M.Phil., Ph.D., CSIR-NET,APSET",
      specialization: "Animal Physiology, Ecology, Endocrinology",
      profileLink: "/zoology/NAGABHUSHAN.pdf"
    },
    {
      id: "zoo005",
      name: "Dr. M. Venkata Chandrudu",
      designation: "Assistant Professor (MTS)",
      email: "chandramidde4@gmail.com",
      mobile: "9963735227",
      photo: "/zoology/chandra_profile1.png",
      qualification: "M.Sc., Ph.D.",
      specialization: "Entomology, Biodiversity",
      profileLink: "/zoology/VENKATA.pdf"
    },
     {
      id: "zoo002",
      name: "Dr. Bandela Vijayudu",
      designation: "Co-ordinator,Assistant Professor (C)",
      email: "bandelavijay5@gmail.com",
      mobile: "8374742791",
      photo: "/zoology/bandela.JPG",
      qualification: "M.Sc., Ph.D.,CSIR-NET,APSET",
      specialization: "Developmental Biology , Genetics and Evaluation",
      profileLink: "/zoology/BANDELA.pdf"
    },
   
    {
      id: "zoo003",
      name: "Dr. R.Sreedhar",
      designation: "Assistant Professor (C)",
      email: "rayasamsreedhar@gmail.com",
      mobile: "9492405600",
      photo: "/zoology/sreedaer.JPG",
      qualification: "M.Sc., Ph.D.",
      specialization: "Toxicology, Environmental Biology",
      profileLink: "/zoology/sreedaer.pdf"
    }
  ],

  courses: {
    // undergraduate: [
    //   {
    //     name: "B.Sc. Zoology",
    //     duration: "3 Years",
    //     eligibility: "10+2 with Biology",
    //     intake: "60 seats"
    //   }
    // ],
    postgraduate: [
      {
        name: "M.Sc. Zoology",
        duration: "2 Years",
        eligibility: "B.Sc. with Zoology",
        intake: "30 seats"
      }
    ],
    // research: [
    //   {
    //     name: "Ph.D. in Zoology",
    //     duration: "Minimum 3 Years",
    //     eligibility: "M.Sc. Zoology",
    //     areas: "Animal Physiology, Ecology, Biodiversity, Entomology"
    //   }
    // ]
  }
,
Infrastructure: [
   "/infrastructure/zoology/class-1.JPG",
  "/infrastructure/zoology/class-2.JPG",
  "/infrastructure/zoology/class-3.JPG",
  "/infrastructure/zoology/class-4.JPG",
   "/infrastructure/zoology/lab-1.JPG",
  "/infrastructure/zoology/lab-2.JPG",
  "/infrastructure/zoology/lab-3.JPG",
  "/infrastructure/zoology/lab-4.JPG",
]
// No infrastructure photos available for Zoology department

};
